import { useQuery } from "@tanstack/react-query";
import { getAirlinesForSelect } from "../../api/apiAirlines";

const QUERY_KEY = ["airlines-select"];

const useGetAirlinesForSelect = () => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: getAirlinesForSelect,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });

  return {
    isLoading,
    error: isError ? error : null,
    airlinesOptions: data?.data || [],
  };
};

export default useGetAirlinesForSelect;
